"use client";

import React from "react";
import { Facebook, Instagram, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
function FooterLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }, {
    icon: Twitter,
    href: "https://soundcloud.com",
    label: "SoundCloud"
  }, {
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }];
  return <section data-section-id="239097" id="footer" className="bg-background text-foreground pt-20 pb-10 border-t border-border">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/HomePage" className="mb-6 inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/pulsewave_studio_logo.png" alt="PulseWave Logo" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-sm text-muted-foreground font-default leading-relaxed max-w-xs">
              PulseWave Studios blends cutting-edge technology with artistic expertise to help musicians bring their sonic visions to life in a high-fidelity environment.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-semibold mb-6 tracking-tight text-foreground">Quick Links</h3>
            <MenuProvider menu_id="44">
              <FooterLinks />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-semibold mb-6 tracking-tight text-foreground">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-muted-foreground">
                <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
                <div className="flex flex-col gap-1">
                  <span>128 Sonic District, Creative Hub, NY</span>
                  <Link to="https://maps.google.com" className="text-primary hover:underline text-xs font-mono">Open in Maps</Link>
                </div>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground">
                <Phone className="size-5 text-primary shrink-0" />
                <span className="font-mono">+1 (555) PULSE-WAVE</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground">
                <Mail className="size-5 text-primary shrink-0" />
                <span className="font-mono">sessions@pulsewave.studio</span>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-semibold mb-6 tracking-tight text-foreground">Studio Status</h3>
            <div className="space-y-4">
              <p className="text-sm text-muted-foreground font-default leading-relaxed">
                Session Hours:<br />
                24/7 Access for Members
              </p>
              <Badge variant="outline" className="mt-2 border-primary/30 bg-primary/10 text-primary gap-2 py-1.5 px-3 shadow-[0_0_15px_rgba(0,255,255,0.2)]">
                <span className="relative flex size-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                  <span className="relative inline-flex rounded-full size-2 bg-primary"></span>
                </span>
                Live Session
              </Badge>
            </div>
          </div>

        </div>

        {}
        <div className="pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-sm text-muted-foreground text-center md:text-left font-default">
            &copy; {currentYear} PulseWave Studios. Designed for Sound.
          </p>
          
          <div className="flex items-center gap-2">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <div key={social.label} data-index={i}>
                  <Button variant="ghost" size="icon" asChild className="text-muted-foreground hover:text-primary hover:bg-primary/10 hover:shadow-[0_0_20px_rgba(0,255,255,0.3)] rounded-full transition-all duration-300">
                    <Link to={social.href} newTab aria-label={social.label}>
                      <Icon className="size-5" />
                    </Link>
                  </Button>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}